<template>
  <v-progress-linear :active="loading" indeterminate/>
</template>

<script>

  export default {
    name: "generic-loader",
    props: {
      trigger: Number
    },
    computed: {
      loading() {
        return false
      },
      refreshTrigger() {
        return this.$store.state.refresh
      }
    },
    watch: {
      trigger(n) {
        this.load()
      },
      refreshTrigger(n) {
        this.load()
      }
    },
    methods: {
      load() {
        return []
      }
    },
    beforeMount() {
      this.load()
    }
  }
</script>

<style scoped>

</style>
